import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/close-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-fc9058c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gallery-modal" }
const _hoisted_2 = {
  class: "gallery-modal-block",
  id: "modalBlock"
}
const _hoisted_3 = { class: "gallery-modal-content" }
const _hoisted_4 = { class: "pre-title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "main-banner" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "close icon"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppGalleryModalVideo = _resolveComponent("AppGalleryModalVideo")!
  const _component_AppGalleryModalPicture = _resolveComponent("AppGalleryModalPicture")!
  const _component_AppSendRequest = _resolveComponent("AppSendRequest")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gallery-modal-wrapper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('galleryModal', false, 0)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.modalData['galleryListProductType']), 1),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.modalData['galleryListProductName']), 1),
        _createElementVNode("picture", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.modalData['galleryListProductBanner'],
            alt: "banner"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.modalData['galleryListProductDescriptionTitle']), 1),
        _createElementVNode("p", {
          class: "text",
          innerHTML: _ctx.modalData['galleryListProductDescription']
        }, null, 8, _hoisted_9),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalData['galleryListProductModalGallery'], (media) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "media wow-modal animate__fadeInUp",
            key: media['imageDesktop'] || media['videoDesktop']
          }, [
            (media['galleryListProductModalGalleryDesktopVideo'])
              ? (_openBlock(), _createBlock(_component_AppGalleryModalVideo, {
                  key: 0,
                  mediaData: media
                }, null, 8, ["mediaData"]))
              : (_openBlock(), _createBlock(_component_AppGalleryModalPicture, {
                  key: 1,
                  mediaData: media
                }, null, 8, ["mediaData"]))
          ]))
        }), 128))
      ]),
      _createVNode(_component_AppSendRequest, {
        variant: 'modal',
        pageData: _ctx.pageData
      }, null, 8, ["pageData"]),
      _createElementVNode("button", {
        class: "btn close-modal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('galleryModal', false, 0)))
      }, _hoisted_11)
    ])
  ]))
}